import { useEffect, useRef } from "react";

const COLORS = ["245,203,92", "250,225,156", "229,179,56", "163,29,61", "135,20,48"];

export default function Particles() {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    const ctx = canvas.getContext("2d");
    const DPR = Math.min(window.devicePixelRatio || 1, 2);
    let w, h, raf;
    const N = window.innerWidth < 768 ? 22 : 42;
    const ps = [];

    const spawn = (any) => ({
      x: Math.random() * w,
      y: any ? Math.random() * h : h + 20,
      r: (Math.random() * 1.8 + 0.6) * DPR,
      s: (Math.random() * 0.25 + 0.08) * DPR,
      o: Math.random() * 0.45 + 0.12,
      c: COLORS[Math.floor(Math.random() * COLORS.length)],
      d: (Math.random() - 0.5) * 0.15 * DPR,
    });

    const resize = () => {
      w = canvas.width = window.innerWidth * DPR;
      h = canvas.height = window.innerHeight * DPR;
      canvas.style.width = window.innerWidth + "px";
      canvas.style.height = window.innerHeight + "px";
    };
    resize();
    window.addEventListener("resize", resize);
    for (let i = 0; i < N; i++) ps.push(spawn(true));

    const tick = () => {
      ctx.clearRect(0, 0, w, h);
      for (const p of ps) {
        p.y -= p.s;
        p.x += p.d;
        if (p.y < -20) Object.assign(p, spawn(false));
        ctx.beginPath();
        ctx.shadowBlur = 8 * DPR;
        ctx.shadowColor = `rgba(${p.c},0.8)`;
        ctx.fillStyle = `rgba(${p.c},${p.o})`;
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fill();
      }
      raf = requestAnimationFrame(tick);
    };
    tick();
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return <canvas ref={ref} data-testid="particles-canvas" className="fixed inset-0 z-0 pointer-events-none" aria-hidden="true" />;
}
